import { __awaiter, __generator } from 'tslib';
import { getMedia } from '@keepeek/api-client';
import Axios from 'axios';
import { selectorFamily } from 'recoil';
import { elementAtom } from './atoms.js';

var elementSelector = selectorFamily({
    key: "ElementSelector",
    get: function (elementId) {
        return function (_a) {
            var get = _a.get;
            return __awaiter(void 0, void 0, void 0, function () {
                var element, mediaResult;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            element = get(elementAtom(elementId));
                            if (element) {
                                return [2 /*return*/, element];
                            }
                            return [4 /*yield*/, getMedia(Axios, {
                                    mediaId: elementId
                                })];
                        case 1:
                            mediaResult = _b.sent();
                            return [2 /*return*/, mediaResult.data];
                    }
                });
            });
        };
    },
    set: function () {
        return function (_a, newValue) {
            var set = _a.set;
            var element = newValue;
            if (element && element.id) {
                set(elementAtom(element.id), element);
            }
        };
    },
    cachePolicy_UNSTABLE: {
        eviction: "most-recent"
    }
});

export { elementSelector };
//# sourceMappingURL=selectors.js.map
